export default {"src":"/_next/static/media/taaftLogo.b3f07938.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};